import script from "./CampCropImageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampCropImageLoader.vue?vue&type=script&setup=true&lang=ts"

import "./CampCropImageLoader.vue?vue&type=style&index=0&id=113f04b8&lang=css"

const __exports__ = script;

export default __exports__